import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const socials = [
  { name: "LinkedIn", href: "#", icon: "linkedin" },
  {
    name: "Instagram",
    href: "https://www.instagram.com/greenexports2025",
    icon: "instagram",
  },
  { name: "Facebook", href: "#", icon: "facebook" },
  { name: "X / Twitter", href: "#", icon: "twitter" },
  { name: "YouTube", href: "#", icon: "youtube" },
  { name: "WhatsApp", href: "#", icon: "whatsapp" },
];

const SocialIcon = ({ type }) => {
  const paths = {
    linkedin:
      "M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.852 3.369-1.852 3.602 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.225 0z",
    instagram: null,
    facebook:
      "M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z",
    twitter:
      "M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417a9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z",
    youtube:
      "M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z",
    whatsapp:
      "M17.6915026,13.4744748 C17.4788064,13.2721827 17.1924068,13.1274098 16.8563168,13.1274098 C16.6844238,13.1274098 16.5474359,13.1787738 16.4573433,13.2274607 L16.4179561,13.2489319 C16.0274926,13.4573887 15.8932243,13.5768202 15.4573268,13.9955964 C15.3183495,14.1255026 15.1449191,14.2285572 14.9531816,14.2285572 C14.8919373,14.2285572 14.8270508,14.2222742 14.7629151,14.2104134 C14.0495798,14.0574181 12.2915503,13.0535495 10.9393994,11.7485201 C9.87553475,10.7384194 9.10293239,9.45495703 9.05471251,9.37527368 C8.98546954,9.20834164 9.08653482,9.01624507 9.25324991,8.84951009 L9.40034523,8.69915179 C9.60098533,8.49420906 9.71267703,8.38216937 9.71267703,8.20433969 C9.71267703,7.88719548 8.64882236,5.84794045 8.42872243,5.52609481 C8.32476703,5.35766149 8.15265197,5.25644234 7.96989023,5.25644234 L7.76137267,5.27774925 C7.54812269,5.30227944 7.34910322,5.41160721 7.21689127,5.56185396 C6.66211264,6.15278261 6.41584491,6.92087373 6.41584491,7.80006174 C6.41584491,9.18187559 7.04147225,10.5062283 8.38283256,12.0018863 C8.50688389,12.1366892 8.63443175,12.2696055 8.76520374,12.3999129 C10.3001938,13.9653121 11.8213104,14.9140996 13.2649024,15.2149766 L13.47829,15.2605203 C13.6268661,15.290886 13.7809277,15.3064941 13.9362071,15.3064941 C14.3880494,15.3064941 14.8319752,15.1305903 15.2096125,14.7872233 C15.2487317,14.7485736 15.2877434,14.709624 15.3263623,14.6699631 C15.7013043,14.2759259 16.3126926,13.8947132 17.1279936,13.6193299 C17.2959672,13.5608451 17.4410767,13.511855 17.5753494,13.511855 L17.5871662,13.5119039 C17.8126876,13.5119039 18.0196176,13.4174953 18.1691293,13.2703742 L18.2067457,13.233013 C18.404916,13.0335357 18.5383481,12.771452 18.5383481,12.4757255 C18.5383481,12.1404659 18.438876,11.8501031 18.2542519,11.6392526 L18.2091923,11.5882256 L17.6915026,13.4744748 Z M12.0060585,2 C6.47474359,2 2,6.50215396 2,12.0565224 C2,14.0872045 2.62150614,16.0076623 3.76019886,17.5821329 L2.69168903,21.9980278 L7.29109944,20.8588233 C8.81099368,21.8624066 10.6530767,22.4679935 12.6030584,22.4679935 C18.1343633,22.4679935 22.6103565,17.9658394 22.6103565,12.4114711 C22.6103565,9.37172874 21.4272923,6.55363933 19.3827804,4.51223394 C17.3382686,2.47082854 14.5400088,2 12.0060585,2 Z",
  };

  if (type === "instagram") {
    return (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
        <rect
          x="2"
          y="2"
          width="20"
          height="20"
          rx="5"
          ry="5"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        />
        <circle
          cx="12"
          cy="12"
          r="3.5"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        />
        <circle cx="17.5" cy="6.5" r="1.5" fill="currentColor" />
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
      <path d={paths[type]} />
    </svg>
  );
};

const certs = [
  "FSSAI",
  "APEDA",
  "HACCP",
  "ISO 22000",
  "GlobalG.A.P.",
  "Spices Board",
];
const payments = ["T/T", "L/C", "D/A", "D/P"];

export default function Footer() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const navigate = useNavigate();

  const subscribe = (e) => {
    e.preventDefault();
    if (!email) return;
    setDone(true);
    setEmail("");
    setTimeout(() => setDone(false), 4000);
  };

  return (
    <footer className="relative mt-10">
      {/* ── Newsletter banner ── */}
      {/* <div className="relative z-10 w-full px-4 sm:px-6 lg:px-10 max-w-400 mx-auto">
        <div className="relative glass-strong shimmer-border rounded-4xl p-6 sm:p-8 md:p-12 overflow-hidden noise">
          <div className="absolute -top-24 -right-24 w-80 h-80 rounded-full bg-indigo-500/15 blur-3xl" />
          <div className="absolute -bottom-24 -left-24 w-80 h-80 rounded-full bg-amber-400/12 blur-3xl" />
          <div className="relative grid md:grid-cols-2 gap-6 md:gap-8 items-center">
            <div>
              <div className="inline-flex items-center gap-2 glass-pill rounded-full px-4 py-1.5 mb-4">
                <span className="text-[11px] uppercase tracking-[0.22em] text-emerald-700">
                  Trade Pulse · Monthly
                </span>
              </div>
              <h3 className="font-display text-2xl sm:text-3xl md:text-4xl font-semibold leading-tight text-stone-900">
                Seasonality, pricing &amp; origin insights —{" "}
                <span className="text-gradient">in your inbox.</span>
              </h3>
              <p className="mt-3 text-stone-600 text-xs sm:text-sm md:text-base">
                Harvest windows, commodity outlooks, and shipping lane updates
                for buyers of Indian produce.
              </p>
            </div>
            <form onSubmit={subscribe} className="w-full md:justify-self-end">
              <div className="glass rounded-2xl p-1 sm:p-1.5 flex flex-col sm:flex-row items-stretch sm:items-center gap-2">
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="your@company.com"
                  className="flex-1 bg-transparent px-3 sm:px-4 py-2 sm:py-3 text-xs sm:text-sm text-stone-900 placeholder-stone-400 outline-none"
                />
                <button
                  type="submit"
                  className="shrink-0 px-4 sm:px-5 py-2 sm:py-3 rounded-xl text-xs sm:text-sm font-medium text-white bg-linear-to-br from-emerald-700 to-teal-700 hover:from-emerald-600 hover:to-emerald-700 transition shadow-lg shadow-emerald-600/20 cursor-pointer whitespace-nowrap"
                >
                  {done ? "✓ Subscribed" : "Subscribe"}
                </button>
              </div>
              <p className="text-[10px] sm:text-[11px] text-stone-400 mt-2 px-1">
                No spam. Unsubscribe in one click.
              </p>
            </form>
          </div>
        </div>
      </div> */}

      {/* ── Divider ── */}
      <div className="relative z-10 w-full px-4 sm:px-6 lg:px-10 max-w-400 mx-auto mt-10">
        <div className="flex items-center gap-4">
          <div
            className="h-px flex-1"
            style={{
              background:
                "linear-gradient(90deg, transparent, rgba(50,70,20,0.15), transparent)",
            }}
          />
          <div className="flex items-center gap-2 glass-pill rounded-full px-4 py-1.5 shrink-0">
            <span className="w-1.5 h-1.5 rounded-full bg-emerald-500" />
            <span className="text-[10px] uppercase tracking-[0.22em] text-stone-500">
              Est. India
            </span>
            <span className="w-1.5 h-1.5 rounded-full bg-emerald-500" />
          </div>
          <div
            className="h-px flex-1"
            style={{
              background:
                "linear-gradient(90deg, transparent, rgba(50,70,20,0.15), transparent)",
            }}
          />
        </div>
      </div>

      {/* ── Main body ── */}
      <div className="relative pt-14 pb-10">
        <div className="relative w-full px-4 sm:px-6 lg:px-10 max-w-400 mx-auto">
          <div className="grid md:grid-cols-2 lg:grid-cols-12 gap-10">
            {/* Brand */}
            <div className="md:col-span-2 lg:col-span-4">
              <img
                src="/myriad-energy-logo.png"
                alt="Myriad Green Energy"
                className="w-[145px] h-[125px] md:w-[145px] md:h-[125px] p-1 mt-[-24px] cursor-pointer scale-135"
                onClick={() => {
                  navigate("/");
                }}
              />

              <p className="mt-5 text-sm text-stone-500 leading-relaxed">
                A trusted exporter of premium fresh vegetables, aromatic spices,
                tropical fruits, and processed agricultural produce — delivering
                Indian farm excellence to over 30 countries worldwide.
              </p>

              {/* Socials */}
              {/* <div className="mt-6">
                <div className="text-[11px] uppercase tracking-[0.22em] text-stone-400 mb-3">
                  Follow Us
                </div>
                <div className="flex items-center gap-2">
                  {socials.map((s) => (
                    <a
                      key={s.name}
                      href={s.href}
                      aria-label={s.name}
                      className="w-9 h-9 rounded-xl glass hover:bg-white/10 transition flex items-center justify-center group"
                    >
                      <span className="text-stone-500 group-hover:text-amber-700 transition">
                        <SocialIcon type={s.icon} />
                      </span>
                    </a>
                  ))}
                </div>
              </div> */}

              {/* Certifications */}
              <div className="mt-6">
                <div className="text-[11px] uppercase tracking-[0.22em] text-stone-400 mb-1">
                  Certifications
                </div>
                <div className="text-[10px] text-stone-400 mb-3">
                  Best as per international standards
                </div>
                <div className="flex flex-wrap gap-1.5">
                  {certs.map((c) => (
                    <span
                      key={c}
                      className="glass-pill rounded-full px-2.5 py-1 text-[10px] uppercase tracking-wide text-stone-500"
                    >
                      {c}
                    </span>
                  ))}
                </div>
              </div>
            </div>

            {/* Produce */}
            <div className="lg:col-span-2">
              <FooterCol
                title="Produce"
                items={[
                  { label: "Vegetables", to: "/products/vegetables" },
                  { label: "Spices", to: "/products/spices" },
                  { label: "Fresh Fruits", to: "/products/fruits" },
                  { label: "Processed", to: "/products/processed" },
                  { label: "All Products", to: "/products" },
                ]}
              />
            </div>

            {/* Company */}
            <div className="lg:col-span-2">
              <FooterCol
                title="Company"
                items={[
                  { label: "About Us", to: "/about" },
                  { label: "Why Us", to: "/why-us" },
                  { label: "Global Reach", to: "/global-reach" },
                  { label: "Contact", to: "/contact" },
                ]}
              />
            </div>

            {/* Services */}
            <div className="lg:col-span-2">
              <FooterCol
                title="Services"
                items={[
                  { label: "Cold Chain", to: "/why-us" },
                  { label: "Custom Packaging", to: "/why-us" },
                  { label: "Documentation", to: "/why-us" },
                  { label: "Private Label", to: "/contact" },
                  { label: "Bulk FCL / LCL", to: "/contact" },
                  { label: "Annual Contracts", to: "/contact" },
                ]}
              />
            </div>

            {/* Contact */}
            <div className="lg:col-span-2">
              <div className="text-[11px] uppercase tracking-[0.22em] text-stone-400 mb-5">
                Get in Touch
              </div>
              <ul className="space-y-4 text-sm">
                <li>
                  <div className="text-[10px] uppercase tracking-widest text-stone-400 mb-1">
                    Email
                  </div>
                  <a
                    href="mailto:info@myriadgreenenergy.in"
                    className="text-stone-600 hover:text-amber-700 transition text-xs break-all"
                  >
                    info@myriadgreenenergy.in
                  </a>
                </li>
                <li>
                  <div className="text-[10px] uppercase tracking-widest text-stone-400 mb-1">
                    Phone
                  </div>
                  <a
                    href="tel:+919960739464"
                    className="text-stone-600 hover:text-amber-700 transition text-xs"
                  >
                    +91 99607 39464
                  </a>
                </li>
                <li>
                  <div className="text-[10px] uppercase tracking-widest text-stone-400 mb-1">
                    Office Hours
                  </div>
                  <div className="text-stone-600 text-xs">Mon – Sat</div>
                  <div className="text-stone-400 text-[11px]">
                    09:00 – 19:00 IST
                  </div>
                </li>
                <li>
                  <div className="text-[10px] uppercase tracking-widest text-stone-400 mb-1">
                    Head Office
                  </div>
                  <div className="text-stone-600 text-xs">
                    Sr.No 138 Plot No 89 Hissa No 3, Siddhi Green Phase 4,
                    Fursungi Road, Bhinde Safalya House,
                    Pune, Maharashtra – 412308, India
                  </div>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom bar */}
          <div className="mt-14 mb-6 text-center">
            <p className="font-display text-base text-stone-400 italic">
              "Empowering Farmers, Delivering Excellence"
            </p>
          </div>

          <div className="pt-6 border-t border-stone-900/8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <div className="text-xs text-stone-400">
              © {new Date().getFullYear()} Myriad Green Energy Pvt. Ltd. · All
              rights reserved.
            </div>
            <div className="flex items-center gap-2">
              <span className="text-[11px] text-stone-400 mr-1">Powered By <a href="https://balsoordigital.in/" target="_blank" rel="noopener noreferrer" className="text-stone-800 hover:text-amber-700 hover:underline transition">Balsoor Digital</a></span>
            </div>
            <div className="flex items-center gap-4 text-xs">
              <Link
                to="/contact"
                className="text-stone-400 hover:text-amber-700 transition"
              >
                Privacy Policy
              </Link>
              <span className="text-stone-200">·</span>
              <Link
                to="/contact"
                className="text-stone-400 hover:text-amber-700 transition"
              >
                Terms of Trade
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, items }) {
  return (
    <div>
      <div className="text-[11px] uppercase tracking-[0.22em] text-stone-400 mb-5">
        {title}
      </div>
      <ul className="space-y-3 text-sm">
        {items.map((i) => (
          <li key={i.label}>
            <Link
              to={i.to}
              className="text-stone-500 hover:text-amber-700 transition"
            >
              {i.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
